import angular from 'angular'

// components
import editVoices from './component/editVoices.component'

export default angular
  .module('portalApp.manage.editVoices', [])
  .component('editVoices', editVoices)
  .name
